"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatHouseholdNumber = void 0;
var React = __importStar(require("react"));
var pinata_1 = require("@snoam/pinata");
var DIService_1 = __importDefault(require("./DIService"));
var isEqual = require("react-fast-compare");
function formatHouseholdNumber(floorType, floorNo, flatNo) {
    if (floorType !== undefined && floorNo !== undefined && flatNo !== undefined) {
        return "".concat(floorType).concat(floorNo < 10 ? '0' + floorNo : floorNo).concat(flatNo < 10 ? '0' + flatNo : flatNo);
    }
    return '';
}
exports.formatHouseholdNumber = formatHouseholdNumber;
var Household = (function (_super) {
    __extends(Household, _super);
    function Household(props) {
        var _this = _super.call(this, props) || this;
        _this.onBlurHousehold = function (__event) {
            var value = __event.target.value;
            var household = _this.state.diResponse.find(function (item) { return item.value === value; });
            if (household) {
                _this.onHouseHoldClick(household.household);
            }
        };
        _this.onChangeHousehold = function (__event) {
            var value = __event.target.value;
            if (value !== "") {
                if (value.length > 5) {
                    _this.setState({ errorMessage: 'Maks 5 tegn', valid: false });
                    return;
                }
                _this.setState({ errorMessage: "" });
            }
            var household = _this.state.diResponse.find(function (item) { return item.value === __event.target.value; });
            if (household) {
                _this.onHouseHoldClick(household.household);
            }
            else {
                _this.setState({
                    value: value,
                });
            }
        };
        _this.onHouseHoldClick = function (household) {
            var floor = _this.props.floor;
            _this.setState({
                value: formatHouseholdNumber(floor.floorType, floor.floorNo, household.flatNo),
                valid: true
            });
            _this.props.updateHousehold(household);
        };
        _this.fetchHouseholds = function () {
            var DIservice = new DIService_1.default({});
            _this.setState({
                errorMessage: '',
                valid: false,
                value: '',
                selectedHousehold: {}
            });
            var _a = _this.props, floor = _a.floor, deliveryPointId = _a.deliveryPointId;
            if (!floor) {
                _this.setState({ diResponse: [] });
            }
            DIservice.fetchHousholds(floor, deliveryPointId)
                .then(function (households) {
                var formatHouseholds = households.map(function (household) {
                    return {
                        content: React.createElement("span", null, formatHouseholdNumber(floor.floorType, floor.floorNo, household.flatNo)),
                        household: household,
                        onClick: function () { return _this.onHouseHoldClick(household); },
                        value: formatHouseholdNumber(floor.floorType, floor.floorNo, household.flatNo),
                    };
                });
                if (formatHouseholds.length === 0) {
                    _this.setState({
                        errorMessage: "Fant ikke nr",
                        valid: false
                    });
                }
                _this.setState({ diResponse: formatHouseholds });
            });
        };
        var houseHold = props.houseHold, floor = props.floor;
        var isPopulated = Object.keys(houseHold).length > 0;
        _this.state = {
            value: isPopulated ? formatHouseholdNumber(floor.floorType, floor.floorNo, houseHold.flatNo) : '',
            errorMessage: "",
            valid: isPopulated,
            diResponse: [],
            selectedHousehold: houseHold
        };
        return _this;
    }
    Household.prototype.UNSAFE_componentWillReceiveProps = function (nextProps, nextContext) {
        var nextHousehold = nextProps.houseHold;
        var selectedHousehold = this.state.selectedHousehold;
        if (!isEqual(nextHousehold, selectedHousehold)) {
            this.setState({
                selectedHousehold: nextHousehold
            });
        }
    };
    Household.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps !== this.props) {
            if (this.props.deliveryPointId) {
                this.props.floor !== prevProps.floor ? this.fetchHouseholds() : null;
            }
            else {
                this.setState({
                    value: "",
                    valid: false,
                    errorMessage: "",
                    diResponse: [],
                    selectedHousehold: {}
                });
            }
        }
    };
    Household.prototype.render = function () {
        var _a = this.state, value = _a.value, valid = _a.valid, errorMessage = _a.errorMessage, diResponse = _a.diResponse;
        var _b = this.props, deliveryPointId = _b.deliveryPointId, showErrors = _b.showErrors;
        return (React.createElement(React.Fragment, null, deliveryPointId && diResponse.length > 0 ?
            React.createElement(pinata_1.FilteringAutosuggest, { value: value, data: diResponse, autoComplete: "off", errorMsg: showErrors && errorMessage, validMsg: showErrors && valid, label: 'Leilighetsnummer', onBlur: this.onBlurHousehold, onChange: this.onChangeHousehold })
            : null));
    };
    Household.defaultProps = {
        houseHold: {}
    };
    return Household;
}(React.PureComponent));
exports.default = Household;
//# sourceMappingURL=Household.js.map